import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import { IsoDate, Contact, Address } from '../definitions/Common';
import { InsuranceTypes } from '../definitions/InsCommon';


const Application = types
    .model('Application', {
        id: types.optional(types.identifier, () => uuid()),

        address: types.maybe(Address),
        contact: types.maybe(Contact),
        insuranceType: types.optional(types.string, InsuranceTypes.HOME), // defaults to 'home' if no type is specified
        policyStart: types.maybe(IsoDate),
    });

export default Application;
